// @flow
import type {RequestParams} from '../typedef';

const prepareBody = (data: RequestParams): FormData => {
    const form = new FormData();

    // TODO: Remove when MFE's update OAG, for new versions.

    if (Array.isArray(data?.file) && data.file && data.key) {
        data.file.forEach((currentFile, idx) => form.append(`${data.key}[${idx}]`, currentFile, currentFile.name));

        return form;
    } else if (data.file && data.key) {
        form.append(data.key, data.file, data.file.name);

        return form;
    }

    Object.keys(data).forEach(key => {
        const value = data[key];

        if (Array.isArray(value) && value.length && value[0] instanceof File) {
            // Handle multiple files.
            value.forEach((item, idx) => {
                if (item instanceof File) {
                    form.append(`${key}[${idx}]`, item, item.name);
                }
            });
        } else if (value instanceof File) {
            // Handle single file
            form.append(key, value, value.name);
        } else if (value === null) {
            // Handle null.
            form.append(key, value);
        } else if (value !== undefined) {
            // Handle multiple types of data.
            form.append(key, JSON.stringify(value));
        }
    });

    return form;
};

type PrepareFileData = { params: RequestParams } => {
    body: FormData,
};

export const prepareFileData: PrepareFileData = ({params}) => ({
    body: prepareBody(params)
});

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
